import { Select as CcSelect } from 'calc-controls';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label?: string;
  options: SelectOption[];
  value: string;
  onChange?: (value: string) => void;
  hint?: string;
}

/**
 * Styled select backed by calc-controls `Select` (inline mode).
 * Disabled options are guarded at commit time since the underlying control
 * does not honour the `disabled` attribute on individual options.
 */
export function Select({
  label,
  options,
  value,
  onChange,
  hint,
  className = '',
}: SelectProps) {
  return (
    <div className={`select-wrapper ${className}`.trim()}>
      {label ? (
        <label className="field-label">
          {label}
        </label>
      ) : null}
      <CcSelect
        label={label}
        options={options.map(({ value: v, label: l }) => ({ value: v, label: l }))}
        value={value}
        onChange={(v) => {
          const opt = options.find((o) => o.value === v);
          if (opt?.disabled) return;
          onChange?.(v);
        }}
        inline
      />
      {hint ? <p className="field-hint">{hint}</p> : null}
    </div>
  );
}
